import React from "react"
import { graphql } from "gatsby"

import Layout from "components/Layout"
import Seo from "components/Seo"
import PageHeader from "components/PageHeader"

import { Grid, Content, Positions, Baner } from "page_components/careers"

const Careers = ({ data, location }) => {
  const pageData = data.allWpPage.nodes[0]
  const positionsData = data.allWpCareer.nodes
  const servicesCategoriesData = data.allWpCategory.nodes.filter(
    service => service.services.nodes.length > 0
  )

  return (
    <Layout location={location} services={servicesCategoriesData}>
      <PageHeader title={pageData.title} />
      <Grid data={pageData.acfCareers} positions={positionsData} />
      <Content data={pageData.acfCareers} />
      <Positions data={pageData.acfCareers} positions={positionsData} />
      <Baner data={pageData.acfCareers} />
    </Layout>
  )
}

export const Head = ({ data, location }) => (
  <Seo
    title={data.allWpPage.nodes[0].seo.title ?? data.allWpPage.nodes[0].title}
    description={data.allWpPage.nodes[0].seo.metaDesc}
    pathname={location.pathname}
  />
)

export const query = graphql`
  query {
    allWpPage(filter: { id: { eq: "cG9zdDo4NTE=" } }) {
      nodes {
        title
        seo {
          title
          metaDesc
        }
        acfCareers {
          careersHeroThumbnail {
            sourceUrl
          }
          careersHeroContent {
            heading {
              title
              highlight
            }
            text
          }
          careersContentThumbnail {
            sourceUrl
          }
          careersContentDescription {
            heading
            text
          }
          careersBenefitsHeading
          careersBenefitsItems {
            icon {
              sourceUrl
            }
            text
          }
          careersPositionHeading
          careersPositionText
          careersBannerHeading
          careersBannerText
        }
      }
    }

    allWpCategory(
      filter: { language: { code: { eq: EN } } }
      sort: { name: ASC }
    ) {
      nodes {
        name
        services {
          nodes {
            title
            slug
            acfServices {
              servicesOrder {
                home
                menu
              }
              aboutHero {
                icon {
                  sourceUrl
                }
              }
            }
          }
        }
        description
      }
    }

    allWpCareer(
      sort: { date: DESC }
      filter: { language: { code: { eq: EN } } }
    ) {
      nodes {
        id
        title
        slug
        content
        date
        seo {
          title
          metaDesc
        }
        acfCareer {
          availableRemoteWork
          minimumRequirements
          officeLocation
          payBenefits
          responsibilities
        }
        language {
          code
        }
      }
    }
  }
`

export default Careers
